export enum ActionStatus {
  IDENTIFIED,
  PLANNED,
  ONGOING,
  DONE,
  VERIFIED,
}

export enum ActionEffectivenessCompliance {
  Yes=1, No, Partially
}

export type Action = {
  id: number
  causeDescription: string
  effectivenessCompliance:  ActionEffectivenessCompliance | null
  evidenceIds: number[]
  issueDescription: string
  followUpId: string
  perimeterId: number | null
  status: ActionStatus
  what: string
  person: number
  when: string
  actionCategoryId: number | null
  actionPriorityId: number | null
  standardsIds: number[]
  productId: number | null
  actionPlanSourceId: number | null
  editable: boolean
  gmaoWorkOrderId: string
  gmaoWorkOrderUrl: string
  isSentToGMAO: boolean
}

